import clsx from 'clsx';
import { IoCheckmark } from 'react-icons/io5';

const CustomCheckbox = ({ id, checked, onChange, label }) => (
  <div className="flex items-center space-x-3">
    <div className="relative flex-shrink-0 mt-1">
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only"
      />
      <label
        htmlFor={id}
        className={clsx(
          'flex items-center justify-center w-8 h-8 border-2 rounded cursor-pointer transition-colors duration-200',
          checked
            ? 'bg-green-600 border-green-600'
            : 'border-gray-300 bg-white',
        )}
      >
        {checked && <IoCheckmark className="w-6 h-6 text-white" />}
      </label>
    </div>
    <label
      htmlFor={id}
      className="text-xl text-gray-700 pt-2 geomanistMedium h-full cursor-pointer leading-relaxed"
    >
      {label}
    </label>
  </div>
);

export default CustomCheckbox;
